import { createContext } from "react";

import MenuGroup from "api/types/MenuGroup";
import MenuItem from "api/types/MenuItem";

const MenuGroupContext = createContext<{
	group: MenuGroup;

	menuItemById: {
		[menuItemId: string]: MenuItem;
	};
}>(undefined as any);

export default MenuGroupContext;
